// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__WdWWy","sendOtp":"AuthorizeToLogin_sendOtp__3fUWs"};